import { css } from 'styled-components';

export const brandSpecificNavBorderStyle = css``;
